// extracted by mini-css-extract-plugin
export var addButton = "SaleDetail-module--addButton--N+gl7";
export var container = "SaleDetail-module--container--acDiV";
export var content = "SaleDetail-module--content--3QGWz";
export var header = "SaleDetail-module--header--uKso5";
export var label = "SaleDetail-module--label--PObYa";
export var noSuppliers = "SaleDetail-module--noSuppliers--jnFXi";
export var subHeader = "SaleDetail-module--subHeader--j8+E9";